module.exports = __webpack_public_path__ + "img/U9.a0db45e7.png";